
export const TRADE_OBJECTS = {
    COUNTRY: 'market',
    CASH_ACCOUNT: 'cashAccount',
    PORTFOLIO_ID: 'portfolioID',
    ESTIMATED_NET_AMOUNT: 'estimatedNetAmount',
    LAST_PRICE: 'lastPrice',
    ORDER_REFERENCE: 'orderReference',
    CHANNEL: 'channel',
    QUANTITY: 'quantity',
    LIMIT_PRICE: 'limitPrice',
    EXPIRY_DATE: 'expiryDate',
    ORDER_DATE: 'orderDate',
    STATUS: 'status',
    EXECUTED_QTY: 'executedQuantity',
    PENDING_QTY: 'pendingQuantity',
    EXECUTION_DATE: 'executionDate',
    EXECUTION_PRICE: 'executionPrice',
    TRAN_REFERENCE: 'transactionReference',
    ORDER_TYPE: 'orderType',
    DEFAULT: 'DEFAULT',
    PRICE_DATE: 'priceDate',
    ISIN: 'isin',
    TICKER: 'ticker',
    QTY_HELD: 'qtyHeld',
    VALOREN: 'valoren',
    RIC_CODE: 'ricCode',
    ESTIMATED_GROSS_AMOUNT: 'estimatedGrossAmount',
    MARKETPRICE: 'marketPrice',
    SECURITYPRICE: 'securityPrice',
    MATURITYDATE: 'maturityDate',
    UNREALISEDGL: 'unrealisedGLPositionCurrency',
    AVGPURCHASEPRICE: 'averagePurchasePrice',
    PROPORTION: 'proportion',
    ACCRUEDINTEREST: 'accruedInterest',
    RATING: 'rating'
  };

  export const ORDER_OBJECT_TYPE = {
    TEXT: 'text',
    CURRENCY: 'currency',
    DATE: 'date',
    NUMBER: 'number'
  }

  export const NO_DATA = '—';

  export const TEXT_SIZE ={
    NORMAL:'normal',
    LARGE:'large'
  }

  export const CTA = {
    CANCELLATION: "CANCELLATION",
    APPROVAL: "APPROVAL",
    MODIFICATION: "MODIFICATION",
    SEETRANSACTIONS: "SEETRANSACTIONS",
    BUY: "BUY",
    SELL: "SELL",
    CONFIRMATION: "CONFIRMATION",
    CONTINUE: "CONTINUE"
  };

  export const TRADE_COLORS = {
    EQUITY: "#5C9AC8",
    GRAPH_POPOVER: "#000D28",
    CHART: "#A4CDE1"
  }
  
  export const CHART_CONFIG = {
    MAX_HEIGHT: 300,
    MARGIN: {
      LEFT: 50,
      RIGHT: 37,
      TOP: 40,
      BOTTOM: 30
    },
    PADDINGS: {
      LEFT: 30,
      RIGHT: 10,
      TOP: 5,
      BOTTOM: 5
    },
    COLOR: TRADE_COLORS.CHART,
    DATE_FORMAT_OPTIONS_FLAG: {
      weekday: 'short', month: 'short', day: 'numeric'
    },
    DATE_FORMAT_OPTIONS_X_AXIS: {
      day: 'numeric', month: 'short'
    }
  }
  
export const ENTITLEMENT = {
  tradingModule :'p4',
  YES: "Y",
  NO: "N"
};

export const ASSETS ={
  EQUITY: 'equities',
  BONDS: 'bonds',
  CASH: 'cash'
}
